import { apiClient } from './client';

export interface MdmBudgetStatusDto {
  budgetStatusId: number;
  budgetStatusName: string;
  budgetStatusDesc?: string;
  displayOrder: number;
  isActive: boolean;
  backgroundColor: string;
  textColor: string;
}

export const budgetStatusApi = {
  list(): Promise<MdmBudgetStatusDto[]> {
    return apiClient.get<{ items: MdmBudgetStatusDto[] }>('/api/budget-statuses').then(r => r.items || []);
  },
};
